(() => {
  // Continuous review strip: the set of cards is repeated until it covers the visible width plus
  // one set, then the track slides exactly one set width and starts over without a visible jump.
  const SPEED = 38; // px per second
  const initialize = (root) => {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = 'true';
    const viewport = root.querySelector('[data-reviews-viewport]');
    const track = root.querySelector('[data-reviews-track]');
    const toggle = root.querySelector('[data-reviews-toggle]');
    const label = root.querySelector('[data-reviews-toggle-label]');
    const originals = [...track.children];
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let lastWidth = 0;
    const build = () => {
      track.querySelectorAll('[data-review-clone]').forEach((clone) => clone.remove());
      root.classList.remove('is-animated');
      lastWidth = viewport.clientWidth;
      if (reduceMotion.matches || !originals.length) { toggle.hidden = true; return; }
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const setWidth = originals.reduce((width, card) => width + card.getBoundingClientRect().width + gap, 0);
      if (!setWidth) return;
      const copies = Math.max(1, Math.ceil(viewport.clientWidth / setWidth));
      for (let i = 0; i < copies; i++) {
        originals.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.dataset.reviewClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
          track.appendChild(clone);
        });
      }
      root.style.setProperty('--rvw-shift', `${-setWidth}px`);
      root.style.setProperty('--rvw-duration', `${(setWidth / SPEED).toFixed(1)}s`);
      viewport.scrollLeft = 0;
      root.classList.add('is-animated');
      toggle.hidden = false;
    };
    toggle.addEventListener('click', () => {
      const paused = root.classList.toggle('is-paused');
      label.textContent = paused ? 'Reanudar' : 'Pausar';
    });
    let resizeTimer;
    new ResizeObserver(() => {
      if (Math.abs(viewport.clientWidth - lastWidth) < 2) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 150);
    }).observe(viewport);
    reduceMotion.addEventListener?.('change', build);
    // No need to animate what nobody is looking at.
    new IntersectionObserver(([entry]) => root.classList.toggle('is-offscreen', !entry.isIntersecting)).observe(root);
    if (document.fonts?.ready) document.fonts.ready.then(build); else build();
  };
  const scan = (container = document) => container.querySelectorAll('[data-robot-reviews]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
